import { h } from 'preact';
import { SelectEntry, TextFieldEntry } from '@epx/flow';

const getServiceTypes = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'WebAPI', label: i18n['opt.WebAPI'] || 'WebAPI' },
  { value: 'WebService', label: i18n['opt.WebService'] || 'Web Service' },
  { value: 'StoredProcedure', label: i18n['opt.StoredProcedure'] || 'Stored Procedure' },
  { value: 'Shell', label: i18n['opt.Shell'] || 'Shell' },
  { value: 'Python', label: i18n['opt.Python'] || 'Python' },
  { value: 'SQL', label: i18n['opt.SQL'] || 'SQL' },
];

const getSubMethodTypes = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'HttpGet', label: i18n['opt.HttpGet'] || 'HTTP GET' },
  { value: 'HttpPost', label: i18n['opt.HttpPost'] || 'HTTP POST' },
  { value: 'HttpPut', label: i18n['opt.HttpPut'] || 'HTTP PUT' },
  { value: 'HttpDelete', label: i18n['opt.HttpDelete'] || 'HTTP DELETE' },
];

export class SfdServiceTaskExtension {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:ServiceTask';
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    const entries = [
      {
        id: 'serviceMethodType',
        component: () => (
          <SelectEntry
            id="sfd-serviceMethodType"
            label={i18n.serviceMethodType || 'Service Method'}
            value={props.serviceMethodType || ''}
            options={getServiceTypes(i18n)}
            onChange={(val) => update('serviceMethodType', val)}
          />
        ),
      },
    ];

    if (props.serviceMethodType === 'WebAPI') {
      entries.push({
        id: 'serviceSubMethodType',
        component: () => (
          <SelectEntry
            id="sfd-serviceSubMethodType"
            label={i18n.subMethodType || 'HTTP Method'}
            value={props.serviceSubMethodType || ''}
            options={getSubMethodTypes(i18n)}
            onChange={(val) => update('serviceSubMethodType', val)}
          />
        ),
      });
    }

    if (props.serviceMethodType) {
      entries.push({
        id: 'serviceArgus',
        component: () => (
          <TextFieldEntry
            id="sfd-serviceArgus"
            label={i18n.argus || 'Arguments'}
            value={props.serviceArgus || ''}
            placeholder="key=value;key2=value2"
            debounce={true}
            onChange={(val) => update('serviceArgus', val)}
          />
        ),
      });
      entries.push({
        id: 'serviceExpression',
        component: () => (
          <TextFieldEntry
            id="sfd-serviceExpression"
            label={i18n.expression || 'Expression'}
            value={props.serviceExpression || ''}
            debounce={true}
            onChange={(val) => update('serviceExpression', val)}
          />
        ),
      });
    }

    return [
      {
        id: 'sfdServiceTask',
        label: i18n.sfdServiceTask || 'SFD Service Options',
        isEdited: () => !!props.serviceMethodType,
        entries,
      },
    ];
  }
}
